import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { MessageCircle } from 'lucide-react';
import { useState } from 'react';

export const InnspillSettings = () => {
  const [enabled, setEnabled] = useState(true);

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <MessageCircle className="w-5 h-5 text-primary" />
          <CardTitle>Innspill</CardTitle>
        </div>
        <CardDescription>
          Administrer brukerinnspill og feedback-funksjoner
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center justify-between">
          <Label htmlFor="innspill-enabled">Aktivert</Label>
          <Switch
            id="innspill-enabled"
            checked={enabled}
            onCheckedChange={setEnabled}
          />
        </div>

        <div className="space-y-2">
          <Label>Moderering</Label>
          <p className="text-sm text-muted-foreground">
            Konfigurer hvordan innspill modereres og vises for lesere.
          </p>
        </div>

        <div className="pt-4 border-t">
          <Button>Lagre innstillinger</Button>
        </div>
      </CardContent>
    </Card>
  );
};
